import { FormattedMessage, useIntl } from 'react-intl';
import { Button, CloseButton, Dialog } from '@/ui';
import { downloadImage, type PictureChannel } from './useShareActions';
import s from './share.module.css';

/**
 * WeChat / QQ: the square card carries the invite QR — the player saves or forwards the picture (no link button,
 * owner decision 30.09). WeChat has no web share intent without a Chinese-registered JS-SDK.
 */
export function WeChatDialog({
  open,
  onClose,
  image,
  channel = 'wx',
  fileName,
}: {
  open: boolean;
  onClose(): void;
  image: string;
  channel?: PictureChannel;
  fileName: string;
}) {
  const intl = useIntl();
  const titleId = channel === 'wx' ? 'share.wechat.title' : 'share.channel.qq';
  return (
    <Dialog open={open} onClose={onClose} label={intl.formatMessage({ id: titleId })} width={440}>
      <div className={s.picture}>
        <div className={s.head}>
          <h2 className={s.title}>
            <FormattedMessage id={titleId} />
          </h2>
          <CloseButton onClick={onClose} />
        </div>
        <img className={s.square} src={image} alt="" width={360} height={360} />
        <p className={s.hint}>
          <FormattedMessage id="share.wechat.hint" />
        </p>
        <p className={s.note}>
          <FormattedMessage id="share.card.free" />
        </p>
        <Button tone="teal" minWidth={200} onClick={() => downloadImage(image, fileName)}>
          <FormattedMessage id="share.wechat.download" />
        </Button>
      </div>
    </Dialog>
  );
}
